module.exports = __webpack_public_path__ + "static/media/undo.3a82037c.svg";